import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardManage from '@/views/marketing/marketingManage/cardManage/index.vue'


const __default__ = { name: 'DcCosFbuCardManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'fbu_card_add_btn',
  edit: 'fbu_card_edit_btn',
  del: 'fbu_card_del_btn',
  qrcode: 'fbu_card_qrcode_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardManage, {
    permission: permission,
    subdomain: "fbu"
  }))
}
}

})